import ListItem from "./ListItem";
import "./style.scss"
function EndorsementsList({ endorsements }: { endorsements: any }) {
  return (
    <div className="endorsment_list my-4">
      <div className="row">
        {endorsements?.map((endorsement: any, i:number) => (
          <div className="col col-lg-4 col-md-6 col-sm-12 gap-5 mb-4" key={i}>
            <div className="card_wrapper">
              <ListItem endorsement={endorsement} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default EndorsementsList;
